import KunLoading80 from './src/index'

KunLoading80.install = function (Vue) {
	Vue.component(KunLoading80.name, KunLoading80);
}

export default KunLoading80;
